import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import DevTools from './components/devtools/DevTools';
import { queryClient } from './lib/query-client';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { applyBranding } from './lib/apply-branding';
import { readCachedBranding } from './lib/branding-cache';
import './lib/i18n';
import './styles/index.css';

// Paint this host's last-known theme synchronously, before React mounts, so a
// revisited concept host is on-theme from the first frame instead of flashing the
// platform default while /concept-config loads. ThemeProvider seeds its initial
// config from the same cache so it never re-applies the default over this.
const cachedBranding = readCachedBranding(window.location.hostname);
if (cachedBranding) applyBranding(cachedBranding);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <App />
            <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
            <DevTools />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
